<template>
  <div class="view-tasklists">
    <user-menu />
    <div class="wrapper page_to_up">
      <masteradmin-sidebar-menu v-if="((masterAdmin === true) && (!$store.state.switch_admin_username))" />
      <admin-sidebar-menu v-if="((admin === true) || ($store.state.switch_admin_username))" />

      <div class="content-wrapper">
      <div class="container-wrapper center">
        <div class="modal-custom" v-show="showOverlay">
          <div class="loader-img-center">
            <i class="fa fa-spinner fa-spin"></i> Please wait...
          </div>
        </div>
        <div>
          <h3 class="d-inline heading">Task Library</h3>
          <button
              v-on:click="isModalVisible = true, verrors.clear()"
              class="btn btn-red btn-md input-height-15 float-right text-align-right"
              ><i class="fa fa-plus spacer-icon" aria-hidden="true"></i>Task</button>
        </div>
        <div class="heading-seperator"></div>
        <div class="margin-bottom-10"></div>

        <div class="" >
          <b-navbar toggleable="lg" type="light" variant="light">
            <b-navbar-brand href="#">Filter/Search</b-navbar-brand>

            <b-navbar-toggle target="nav-collapse"><i class="fa fa-chevron-down	"></i></b-navbar-toggle>


            <b-collapse id="nav-collapse" is-nav>
              <div class="search-wrapper col-12">
                <div class="row col-12  override-padding">
                  <div class="col-lg-6 col-md-12 col-12">
                    <b-form-input
                      class="input-text"
                      v-model="search_keyword"
                      type="text"
                      placeholder="Search by Task Description"
                      @keyup.enter="filterTasklistitems()"
                      maxlength="255"
                    ></b-form-input>
                  </div>
                  <div class="col-lg-2 col-md-12 col-12">
                     <b-form-select
                      class="input-text"
                      v-model="search_priority"
                      :options="priority_options"
                      @change="filterTasklistitems()"
                     >
                     </b-form-select>
                  </div>
                  <div class="col-lg-2 col-md-10 col-10">
                     <b-form-select
                      class="input-text"
                      v-model="search_status"
                      :options="(((masterAdmin === true) && (!$store.state.switch_admin_username)) || (selectedComponent == 'Private')) ? status_options : public_status_options"
                      @change="filterTasklistitems()"
                     >
                     </b-form-select>
                  </div>
                  <div class="col-lg-1 col-md-2 col-2 search-icon-wrapper cursor-pointer" @click="filterTasklistitems()">
                    <span class="search-icon">
                      <i class="fa fa-search"></i>
                    </span>
                  </div>
                  <div class="col-lg-1 col-md-2 col-2 scroll_box cursor-pointer">
                    <span class="scroll_up_down" @click="scrollToElement('down')">
                      <i class="fa fa-angle-down angle_font"></i>
                    </span>
                  </div>
                </div>
              </div>
            </b-collapse>
          </b-navbar>
        </div>
        <div class="margin-bottom-10"></div>
        <form @submit.prevent="onSubmit" v-if="task_list_id > 0">
          <div class="submit float-right col-sm-2 col-3 override-padding">
            <button type="submit" class="btn btn-info btn-md col-12">Save</button>
          </div>
        </form>
        <div style="clear: both;"></div>

          <div>
            <div v-show="verrors.has('tasks')" class="validate-warning-msg">{{ verrors.first('tasks') }}</div>
             <b-card no-body  class="card_class">
               <b-tabs card class="tab_header_class">
                 <b-tab title="Public" @click="selected_component('Public')" v-bind:active="isActive('Public')">

                      <div class="row tasks_heading_row">
                        <div
                          class="bold cursor-pointer col-xl-6 col-lg-5 col-md-5 col-sm-5 col-5"
                          v-on:click="sortMethod('description')"
                          >
                          Task Description
                          <i v-if="publicSortField == 'description' && publicSortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                          <i v-if="publicSortField == 'description' && publicSortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                        </div>
                        <div
                          class="bold cursor-pointer col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 override-padding"
                          v-on:click="sortMethod('status')"
                          >
                          Status
                          <i v-if="publicSortField == 'status' && publicSortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                          <i v-if="publicSortField == 'status' && publicSortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                        </div>
                        <div
                          class="bold cursor-pointer col-xl-1 col-lg-1 col-md-2 col-sm-2 col-2 override-padding"
                          v-on:click="sortMethod('priority')"
                          >
                          Priority
                          <i v-if="publicSortField == 'priority' && publicSortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                          <i v-if="publicSortField == 'priority' && publicSortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                        </div>
                        <div
                          class="bold cursor-pointer col-xl-3 col-lg-4 col-md-2 col-sm-2 col-2 override-padding"
                          v-on:click="sortMethod('createdBy')"
                          >
                          Created By
                          <i v-if="publicSortField == 'createdBy' && publicSortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                          <i v-if="publicSortField == 'createdBy' && publicSortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                        </div>
                      </div>

                      <div v-show="loading" class="loading_show"><div class="spinner-border text-danger"></div></div>
                      <b-card-text v-if="tasks.length > 0">
                      <div class="tasklists-row" v-for="(task, index) in tasks">
                        <div class="row tasklist-item" style="margin: 0px;">
                          <div  class="col-xl-6 col-lg-5 col-md-5 col-sm-5 col-5 ">
                            <div class="col-12 float-left override-padding">
                              <span v-if="index == 0">
                                <input v-if="(task.status == 'PUBLISH' && task_list_id > 0)" :value="task.id" type="checkbox" name="tasks" :id="task.id" v-model="tasks_selected" v-validate data-vv-rules="required" data-vv-as="Tasks">
                              </span>
                              <span v-else>
                                <input v-if="(task.status == 'PUBLISH' && task_list_id > 0)" :value="task.id" type="checkbox" name="tasks" :id="task.id" v-model="tasks_selected">
                              </span>
                              <label :for="task.id">{{task.description}}</label>
                            <button
                                v-on:click="tasklistToolTip(task.tasklists)"
                                v-if="(task.tasklists != null)"
                                class="btn btn-dark-grey in-use-button override-padding"
                                >In Use</button>
                            </div>
                          </div>
                          <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 override-padding">{{ getStatus(task.status) }}</div>
                          <div class="col-xl-1 col-lg-2 col-md-2 col-sm-2 col-2 override-padding">
                            <span v-if="task.priority > 0">&nbsp;P{{ task.priority }}</span>
                          </div>
                          <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 override-padding">
                            {{task.created_by}}
                          </div>

                          <div v-if="((masterAdmin === true) && ((!$store.state.switch_admin_username) || ($store.state.switch_admin_username == '')))" class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-1 override-padding">
                              <div v-bind:id="'dropdown-container'+ index" class="dropdown" @click="toggleDropdown('actionDropdown'+index+'')">
                                <ul class="dropbtn icons btn-right showLeft"  v-bind:id="'dotted-menu' + index">
                                  <li></li>
                                  <li></li>
                                  <li></li>
                                </ul>
                                <div v-bind:id="'actionDropdown' + index" class="dropdown-content">
                                  <div class="action-dd-menu" href="" v-if="((task.status=='DRAFT') || ((task.status == 'PUBLISH') && (masterAdmin == true)))" @click="editTaskMethod(task)"><i class="cursor-pointer fa fa-edit	spacer-icon"></i>Edit</div>
                                  <div class="action-dd-menu" href="" v-if="task.status=='DRAFT'" @click="updateTaskStatus(task.id, 'PUBLISH')"><i class="cursor-pointer fa fa-upload spacer-icon"></i>Publish</div>
                                  <div class="action-dd-menu" href="" v-if="task.status=='DRAFT' || task.status=='DEACTIVATED'" @click="deleteTaskConfirm(task.id, task.description)"><i class="cursor-pointer fa fa-times spacer-icon"></i>Remove</div>
                                  <div class="action-dd-menu" href="" v-if="task.status=='PUBLISH'" @click="deactivateTaskConfirm(task.id)"><i class="cursor-pointer fa fa-eye-slash spacer-icon"></i>Deactivate</div>
                                </div>
                              </div>
                          </div>
                          <div v-else>
                            <div v-bind:id="'dropdown-container'+ index" class="dropdown" @click="toggleDropdown('actionDropdown'+index+'')">
                              <ul class="dropbtn icons btn-right showLeft"  v-bind:id="'dotted-menu' + index">
                              </ul>
                              <div v-bind:id="'actionDropdown' + index" class="dropdown-content">
                              </div>
                            </div>
                          </div>
                        </div>
                        <div><hr></div>
                      </div>
                      <div class="row page_to_down">
                        <div class="mx-auto">
                          <div class="overflow-auto m-3">
                            <b-pagination v-if="rows > 25"
                              v-model="currentPage"
                              :total-rows="rows"
                              :per-page="perPage"
                              first-text="First"
                              prev-text="Prev"
                              next-text="Next"
                              last-text="Last"
                              :hide-goto-end-buttons=false
                              @input="showTasklistofPaginated()"
                              ></b-pagination>
                          </div>
                        </div>
                        <div class="page_angle_down">
                          <div class="scroll_box cursor-pointer">
                            <span class="scroll_up_down" @click="scrollToElement('up')">
                              <i class="fa fa-angle-up angle_font"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                   </b-card-text>
                   <b-card-text v-else-if="loading == false">
                        No task matches your search.
                   </b-card-text>
                 </b-tab>
                 <b-tab title="Private" v-if="((!masterAdmin) || ($store.state.switch_admin_username))" @click="selected_component('Private')" v-bind:active="isActive('Private')">

                     <div class="row tasks_heading_row">
                       <div
                         class="bold cursor-pointer col-xl-6 col-lg-5 col-md-5 col-sm-5 col-5"
                         v-on:click="sortPrivateMethod('description')"
                         >
                         Task Title
                         <i v-if="privateSortField == 'description' && privateSortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                         <i v-if="privateSortField == 'description' && privateSortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                       </div>
                       <div
                         class="bold cursor-pointer col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 override-padding"
                         v-on:click="sortPrivateMethod('status')"
                         >
                         Status
                         <i v-if="privateSortField == 'status' && privateSortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                         <i v-if="privateSortField == 'status' && privateSortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                       </div>
                       <div
                         class="bold cursor-pointer col-xl-1 col-lg-1 col-md-2 col-sm-2 col-2 override-padding"
                         v-on:click="sortPrivateMethod('priority')"
                         >
                         Priority
                         <i v-if="privateSortField == 'priority' && privateSortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                         <i v-if="privateSortField == 'priority' && privateSortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                       </div>
                       <div
                         class="bold cursor-pointer col-xl-3 col-lg-4 col-md-2 col-sm-2 col-2 override-padding"
                         v-on:click="sortMethod('createdBy')"
                         >
                         Created By
                         <i v-if="publicSortField == 'createdBy' && publicSortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                         <i v-if="publicSortField == 'createdBy' && publicSortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                       </div>
                     </div>

                     <div v-show="privateLoading" class="loading_show"><div class="spinner-border text-danger"></div></div>
                     <b-card-text v-if="privateTasks.length > 0">
                      <div class="tasklists-row" v-for="(task, index) in privateTasks">
                        <div class="row tasklist-item" style="margin: 0;">
                          <div  class="col-xl-6 col-lg-5 col-md-5 col-sm-5 col-5 ">
                            <div class="float-left override-padding">
                              <span v-if="index == 0">
                                <input v-if="(task.status == 'PUBLISH' && task_list_id > 0)" :value="task.id" type="checkbox" name="tasks" v-model="tasks_selected" v-validate data-vv-rules="required" data-vv-as="Tasks">
                              </span>
                              <span v-else>
                                <input v-if="(task.status == 'PUBLISH' && task_list_id > 0)" :value="task.id" type="checkbox" name="tasks" v-model="tasks_selected">
                              </span>
                              {{task.description}}
                              <button
                                  v-on:click="tasklistToolTip(task.tasklists)"
                                  v-if="(task.tasklists != null)"
                                  class="btn btn-dark-grey in-use-button override-padding"
                                  >In Use</button>
                            </div>
                          </div>
                          <div class="col-xl-2 col-lg-1 col-md-2 col-sm-2 col-2 override-padding">{{ getStatus(task.status) }}</div>
                          <div class="col-xl-1 col-lg-2 col-md-1 col-sm-2 col-2 override-padding">
                            <span v-if="task.priority > 0">&nbsp;P{{ task.priority }}</span>
                          </div>
                          <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 override-padding">
                            {{task.created_by}}
                          </div>

                          <div v-if="((task.status != 'DEACTIVATED'))" class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-1 override-padding">
                              <div v-bind:id="'dropdown-container-private'+ index" class="dropdown" @click="toggleDropdown('actionPrivateDropdown'+index+'')">
                                <ul class="dropbtn icons btn-right showLeft"  v-bind:id="'dotted-menu-private' + index">
                                  <li></li>
                                  <li></li>
                                  <li></li>
                                </ul>
                                <div v-bind:id="'actionPrivateDropdown' + index" class="dropdown-content-private">
                                  <div class="action-dd-menu" href="" v-if="task.status=='DRAFT'" @click="editTaskMethod(task)"><i class="cursor-pointer fa fa-edit	spacer-icon"></i>Edit</div>
                                  <div class="action-dd-menu" href="" v-if="task.status=='DRAFT'" @click="updateTaskStatus(task.id, 'PUBLISH')"><i class="cursor-pointer fa fa-upload spacer-icon"></i>Publish</div>
                                  <div class="action-dd-menu" href="" v-if="task.status=='DRAFT'" @click="deleteTaskConfirm(task.id, task.description)"><i class="cursor-pointer fa fa-times spacer-icon"></i>Remove</div>
                                  <div class="action-dd-menu" href="" v-if="task.status=='PUBLISH'" @click="deactivateTaskConfirm(task.id)"><i class="cursor-pointer fa fa-eye-slash spacer-icon"></i>Deactivate</div>
                                </div>
                              </div>
                          </div>
                          <div v-else>
                            <div v-bind:id="'dropdown-container-private'+ index" class="dropdown" @click="toggleDropdown('actionPrivateDropdown'+index+'')">
                              <ul class="dropbtn icons btn-right showLeft"  v-bind:id="'dotted-menu-private' + index">
                              </ul>
                              <div v-bind:id="'actionPrivateDropdown' + index" class="dropdown-content-private">
                              </div>
                            </div>
                          </div>
                        </div>
                        <div><hr></div>
                      </div>
                      <div class="row page_to_down">
                        <div class="mx-auto">
                          <div class="overflow-auto m-3">
                            <b-pagination v-if="privateRows > 25"
                              v-model="privateCurrentPage"
                              :total-rows="privateRows"
                              :per-page="perPage"
                              first-text="First"
                              prev-text="Prev"
                              next-text="Next"
                              last-text="Last"
                              :hide-goto-end-buttons=false
                              @input="showPrivateTasklistofPaginated()"
                              ></b-pagination>
                          </div>
                        </div>
                        <div class="page_angle_down">
                          <div class="scroll_box cursor-pointer">
                            <span class="scroll_up_down" @click="scrollToElement('up')">
                              <i class="fa fa-angle-up angle_font"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                   </b-card-text>
                   <b-card-text v-else-if="privateLoading == false">
                        No task matches your search.
                   </b-card-text>

                 </b-tab>
               </b-tabs>
             </b-card>

         </div>
         <form @submit.prevent="onSubmit" v-if="task_list_id > 0">
           <div class="submit float-right margin-bottom-15 col-sm-2 col-3 override-padding">
             <button type="submit" class="btn btn-info btn-md col-12">Save</button>
           </div>
         </form>
      </div>

      <CreateTasklistModal :isModalVisible="isModalVisible" @close="isModalVisible = false">
        <span v-if="loading" class="pull-right text-danger">
          Loading...
        </span>
        <div slot="header" class="sub-heading"><h3>Create Tasks</h3></div>
        <div slot="body" v-if="isModalVisible === true">
          <div class="col-12 override-padding">
            <input
                  v-model="task_title"
                  name="task_title"
                  id="task_title"
                  ref="task_title"
                  placeholder="Enter Task Description"
                  class="col-12 input-height-25"
                  v-validate="'required'"
                  />
            <div v-if="verrors.firstByRule('task_title', 'exists')" class="margin-bottom-5 validate-warning-msg">Task description already exists</div>
            <div v-if="verrors.firstByRule('task_title', 'required')" class="margin-bottom-5 validate-warning-msg">Task description is required</div>
          </div>
          <div style="clear: both;" class="margin-bottom-10"></div>
          <div class="col-12 override-padding">
             <div class="col-lg-5 col-12 float-left override-padding">
               <b-form-select class="input-text" v-model="priority" :options="priority_options"></b-form-select>
             </div>
             <div class="col-lg-6 col-12 float-left override-padding create_tasks_status">
               <div class="col-lg-5 float-left col-12 override-padding" v-for="(option, index) in createtask_status_options">
                 <input :value="option.value" type="radio" name="task_status" v-model="task_status">
                 <label :for="option.groupName">{{ option.text }}</label>
               </div>
             </div>
          </div>
          <div style="clear: both;" class="margin-bottom-10"></div>
          <div class="col-12 override-padding">
            <button
                v-on:click="createTasksAction()"
                class="btn btn-red col-3 float-left input-height-25"
                ><b>Create</b></button>
          </div>
        </div>
        <div slot="footer" class="col-3 override-padding">

        </div>
      </CreateTasklistModal>

      <EditTasksModal :isModalVisible="isEditModalVisible" :editTaskTitle="editTaskTitle" :editTaskPriority="editTaskPriority" :editTaskId="editTaskId" @close="isEditModalVisible = false">
        <span v-if="loading" class="pull-right text-danger">
          Loading...
        </span>
        <div slot="header" class="sub-heading"><h3>Update Tasks</h3></div>
        <div slot="body" v-if="isEditModalVisible === true">
          <div class="col-12 override-padding">
            <input
                  v-model="editTaskTitle"
                  name="editTaskTitle"
                  id="editTaskTitle"
                  ref="editTaskTitle"
                  placeholder="Enter Task Description"
                  class="col-12 input-height-25"
                  v-validate="'required'"
                />
            <div v-if="verrors.firstByRule('editTaskTitle', 'exists')" class="margin-bottom-5 validate-warning-msg">Task description already exists</div>
            <div v-if="verrors.firstByRule('editTaskTitle', 'required')" class="margin-bottom-5 validate-warning-msg">Task description is required</div>
          </div>
          <div style="clear: both;" class="margin-bottom-10"></div>
          <div class="col-12 override-padding">
             <div class="col-lg-9 col-12 float-left override-padding">
               <b-form-select class="col-lg-7 float-left col-12 input-text" v-model="editTaskPriority" :options="priority_options"></b-form-select>
             </div>
             <button
                 v-on:click="updateTasksAction(editTaskId)"
                 class="btn btn-red col-3 float-left input-height-25"
                 style="margin: 10px 0px 0px 0px"
                 ><b>Update</b></button>
          </div>
          <div style="clear: both;" class="margin-bottom-10"></div>
        </div>
        <div slot="footer" class="col-3 override-padding">

        </div>
      </EditTasksModal>

      <DeleteModal :isModalVisible="isDeleteModalVisible" :id="id"  @close="isDeleteModalVisible = false">
        <span v-if="loading" class="pull-right text-danger">
          Loading...
        </span>
        <div slot="header" class="sub-heading">Are you sure you want to delete?</div>
        <div slot="body">

        </div>
        <div slot="footer" class="col-3 override-padding">
          <button class="left col-12 btn btn-red" @click="showingdeleteModal = false; deleteTask(id)">Confirm</button>
        </div>
      </DeleteModal>

      <DeactivateModal :isModalVisible="isDeactivateModalVisible" :id="deactivateId"  @close="isDeactivateModalVisible = false">
        <span v-if="loading" class="pull-right text-danger">
          Loading...
        </span>
        <div slot="header" class="sub-heading">Are you sure you want to deactivate? </div>
        <div slot="body">

        </div>
        <div slot="footer" class="col-3 override-padding">
          <button class="left col-12 btn btn-red" @click="showingdeleteModal = false; deactivateTask(deactivateId)">Confirm</button>
        </div>
      </DeactivateModal>

      <ValidationModal :isModalVisible="isValidationModalVisible" @close="isValidationModalVisible = false">
        <span v-if="loading" class="pull-right text-danger">
          Loading...
        </span>
        <div slot="header" class="sub-heading">Please enter task description</div>
        <div slot="body">

        </div>
        <div slot="footer" class="col-3 override-padding">

        </div>
      </ValidationModal>

      <TaskValidationModal :isModalVisible="isTaskValidationModalVisible" @close="isTaskValidationModalVisible = false">
        <span v-if="loading" class="pull-right text-danger">
          Loading...
        </span>
        <div slot="header" class="sub-heading">Task - '{{ validateTaskName }}' already added in this skill set.</div>
        <div slot="body">

        </div>
        <div slot="footer" class="col-3 override-padding">

        </div>
      </TaskValidationModal>

      <TaskListModal :isModalVisible="isTaskListModalVisible" @close="isTaskListModalVisible = false">
        <span v-if="loading" class="pull-right text-danger">
          Loading...
        </span>
        <div slot="header" class="sub-heading">
          <div>Following tasklists are associated with this task :</div>
          <hr>
          <ul>
            <li v-for="tasklist_list in tasklist_lists">
              {{ tasklist_list }}
            </li>
          </ul>
        </div>
        <div slot="body">

        </div>
        <div slot="footer" class="col-3 override-padding">

        </div>
      </TaskListModal>

      <CheckTaskRepetitionValidationModal :isModalVisible="isTaskRepetitionCountModalVisible" @close="isTaskRepetitionCountModalVisible = false">
        <span v-if="loading" class="pull-right text-danger">
          Loading...
        </span>
        <div slot="header" class="sub-heading">The task "{{ taskDescription }}" has some repetitions recorded, you can't delete this task</div>
        <div slot="body">

        </div>
        <div slot="footer" class="col-3 override-padding">

        </div>
      </CheckTaskRepetitionValidationModal>

      </div>
    </div>
  </div>
</template>

<script>

import Vue from 'vue/dist/vue.esm';
import UserMenu from '../shared/user_menu.vue';
import GoBack from '../shared/goback.vue';
import axios from 'axios';
import router from '../../router/index.js';
import store from '../../store/store.js';
import VeeValidate from 'vee-validate';
import CreateTasklistModal from '../admin/create-tasklist-modal.vue';
import EditTasksModal from '../admin/edit-tasks-modal.vue';
import DeleteModal from '../shared/delete_modal_alert.vue';
import DeactivateModal from '../shared/delete_modal_alert.vue';
import ValidationModal from '../shared/validation_modal_alert.vue';
import TaskValidationModal from '../shared/validation_modal_alert.vue';
import TaskListModal from '../shared/validation_modal_alert.vue';
import MasteradminSidebarMenu from '../shared/masteradmin_sidebar_menu.vue';
import AdminSidebarMenu from '../shared/admin_sidebar_menu.vue';
import CheckTaskRepetitionValidationModal from '../shared/validation_modal_alert.vue';

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

export default {
        data() {
          return {
            sub_tasklist_name: '',
            headings: '',
            isModalVisible: false,
            tasks_selected: [],
            tasks: [],
            privateTasks: [],
            sub_tasklist_obj: {
              headings: [],
              tasks: [],
            },
            loading: false,
            privateLoading: false,
            perPage: 25,
            currentPage: 1,
            privateCurrentPage: 1,
            privateRows: '',
            search_status: '',
            status_options: [
              { value: '', text: 'Status' },
              { value: 'DRAFT', text: 'Draft' },
              { value: 'PUBLISH', text: 'Published' },
              { value: 'DEACTIVATED', text: 'Deactivated' }
            ],
            public_status_options: [
              { value: '', text: 'Status' },
              { value: 'PUBLISH', text: 'Published' },
            ],
            priority_options: [
              { value: '', text: 'Priority' },
              { value: '1', text: 'P1' },
              { value: '2', text: 'P2' },
              { value: '3', text: 'P3' },
              { value: '4', text: 'P4' },
              { value: '5', text: 'P5' },
              { value: '6', text: 'P6' },
              { value: '7', text: 'P7' },
              { value: '8', text: 'P8' },
              { value: '9', text: 'P9' },
              { value: '10', text: 'P10' },
            ],
            priority: '',
            search_priority: '',
            createtask_status_options: [
              { value: 'DRAFT', text: 'Draft' },
              { value: 'PUBLISH', text: 'Published' },
            ],
            masterAdmin: false,
            admin: false,
            search_keyword: '',
            showOverlay: false,
            task_title: '',
            task_status: 'PUBLISH',
            deactivateId: '',
            isDeleteModalVisible: false,
            isDeactivateModalVisible: false,
            id: '',
            task_list_id: '',
            isValidationModalVisible: false,
            isTaskValidationModalVisible: false,
            isTaskListModalVisible: false,
            validateTaskName: '',
            tasklist_lists: '',
            selectedComponent: 'Public',
            isEditModalVisible: false,
            editTaskTitle: '',
            editTaskPriority: '',
            editTaskId: '',
            publicSortField: 'description',
            publicSortBy: 'ASC',
            privateSortField: '',
            privateSortBy: '',
            subTaskIndex: '',
            isTaskRepetitionCountModalVisible: false,
            taskDescription: '',
            getTaskDefaultGoal: {
              rep_count: '',
              rep_hours: '',
              total_hours: '',
            },
          }
        },
        components: {
          UserMenu,
          GoBack,
          CreateTasklistModal,
          DeleteModal,
          DeactivateModal,
          ValidationModal,
          TaskValidationModal,
          TaskListModal,
          EditTasksModal,
          MasteradminSidebarMenu,
          AdminSidebarMenu,
          CheckTaskRepetitionValidationModal
        },
        methods: {
          closeModal() {
            this.$emit('close');
          },
          isActive: function (tabvalue) {
               return this.selectedComponent === tabvalue
          },
          selected_component: function (tabvalue) {
             this.selectedComponent = tabvalue;
             this.search_status = '';
             let page_url = 'Tasks';
             let active_tab = tabvalue;
             this.$store.dispatch('active_tab', { page_url, active_tab })
             this.filterTasklistitems();
          },
          onSubmit () {
              this.$validator.validateAll().then((result) => {
                if(!result) {
                  return;
                }
                this.choosedtasks();
              })
              .catch(() => {
              });
          },
          updateTasksAction: function(taskId) {
            this.$validator.validateAll().then((result) => {
              if ((this.verrors.items.length === 0)) {
                if(this.editTaskPriority == '') {
                  this.editTaskPriority = 'NULL';
                }
                axios('/tasks/' + taskId,
                   {
                     method: 'PATCH',
                     data: {description: this.editTaskTitle, priority: this.editTaskPriority},
                   }
                 )
                .then((resp) => {
                    this.fetchTasklistitems();
                    if((this.masterAdmin == false) || (this.$store.state.switch_admin_username)) {
                      this.fetchPrivateTasklistitems();
                    }
                    this.isEditModalVisible = false;
                 })
                .catch(error => {
                  const fieldErrors =  [];
                  // var errMsgObj = error.response.data.message;
                  var errMsgObj = JSON.parse(error.response.data.message);
                  Object.keys(errMsgObj).map(key => {
                     var newFieldErr = {field:key, msg:errMsgObj[key], rule:'exists'};
                     fieldErrors.push(newFieldErr);
                  });
                  this.$validator.errors.add(fieldErrors);
                  if(error.response.data.code == '404') {
                    router.push("/view-tasklist");
                  }
                })
              }
            })
            .catch(() => {

            });

          },
          editTaskMethod: function(task) {
            this.verrors.clear()
            this.editTaskTitle = task.description;
            this.editTaskPriority = task.priority;
            this.editTaskId = task.id;
            if(!this.editTaskPriority) {
              this.editTaskPriority = '';
            }
            this.isEditModalVisible = true;
          },
          createTasksAction: function() {
            this.$validator.validateAll().then((result) => {
              if (this.verrors.items[0] && this.verrors.items[0].field === 'tasks') {
                this.verrors.items.splice(0, 1);
              }
              if ((this.verrors.items.length === 0)) {
                axios('/tasks',
                   {
                     method: 'POST',
                     data: {description: this.task_title, status: this.task_status, priority: this.priority},
                   }
                 )
                .then((resp) => {
                    this.task_title = '';
                    this.priority = '';
                    this.task_status = 'PUBLISH';
                    this.isModalVisible = false;
                    this.fetchTasklistitems();
                    if((this.masterAdmin == false) || (this.$store.state.switch_admin_username)) {
                      this.fetchPrivateTasklistitems();
                    }
                 })
                .catch(error => {
                  const fieldErrors =  [];
                  // var errMsgObj = error.response.data.message;
                  var errMsgObj = JSON.parse(error.response.data.message);
                  Object.keys(errMsgObj).map(key => {
                     var newFieldErr = {field:key, msg:errMsgObj[key], rule:'exists'};
                     fieldErrors.push(newFieldErr);
                  });
                  this.$validator.errors.add(fieldErrors);
                  if(error.response.data.code == '404') {
                    router.push("/view-tasklist");
                  }
                })
              }
            })
            .catch(() => {

            });
          },
          getStatus: function(status) {
            var status_val = this.status_options.findIndex(item => item.value === status);
            return this.status_options[status_val].text;
          },
          choosedtasks: function() {
            if(this.tasks_selected.length > 0) {
              for(var i=0; i<this.tasks_selected.length; i++) {
                var index = this.tasks.findIndex(item => item.id === this.tasks_selected[i]);
                if(index < 0) {
                  var index = this.privateTasks.findIndex(item => item.id === this.tasks_selected[i]);
                  var selected_tasks = this.privateTasks[index];
                }
                else {
                  var selected_tasks = this.tasks[index];
                }
                var duplicate_flag = this.checkTasksAction(selected_tasks.id);
                if(duplicate_flag == 1) {
                  this.validateTaskName = selected_tasks.description;
                  this.isTaskValidationModalVisible = true;
                  this.tasks_selected.splice(i, 1);
                  return false;
                }
                if(this.subTaskIndex >= 0) {
                  this.sub_tasklist_obj.subtaskupdate = true;
                  this.sub_tasklist_obj.skills[this.subTaskIndex].tasks_count = (parseInt(this.sub_tasklist_obj.skills[this.subTaskIndex].tasks_count) + parseInt(1));
                  var task_id = selected_tasks.id; 
                  this.getTaskDefaultGoal = {
                    rep_count: 3,
                    rep_competency: 3,
                  };
                  for(var j=0; j < this.sub_tasklist_obj.skills.length; j++) {
                    for(var x=0; x < this.sub_tasklist_obj.skills[j].tasks.length; x++) {
                        if(task_id == this.sub_tasklist_obj.skills[j].tasks[x].id) {
                          this.getTaskDefaultGoal.rep_count = this.sub_tasklist_obj.skills[j].tasks[x].defaultRepCount;
                          this.getTaskDefaultGoal.rep_competency = this.sub_tasklist_obj.skills[j].tasks[x].defaultRepCompetency;
                        }  
                    }
                  }
                  var rep_count = this.getTaskDefaultGoal.rep_count;
                  var rep_competency = this.getTaskDefaultGoal.rep_competency;
                  var heading_sort_id = this.sub_tasklist_obj.skills[this.subTaskIndex].sortid;
                  var task_len = this.sub_tasklist_obj.skills[this.subTaskIndex].tasks.length + 1;
                  this.sub_tasklist_obj.skills[this.subTaskIndex].tasks.push({
                    id: selected_tasks.id,
                    name: selected_tasks.description,
                    priority: selected_tasks.priority,
                    edit: false,
                    update: false,
                    modified: false,
                    sortid: heading_sort_id + '-task-' + task_len,
                    defaultRepCount: rep_count,
                    defaultRepCompetency: rep_competency,
                  });
                }
                else {
                  var task_len = this.sub_tasklist_obj.tasks.length + 1;
                  var task_id = selected_tasks.id; 
                  this.getTaskDefaultGoal = {
                    rep_count: 3,
                    rep_competency: 3,
                  };
                  var rep_count = this.getTaskDefaultGoal.rep_count;
                  var rep_competency = this.getTaskDefaultGoal.rep_competency;
                  this.sub_tasklist_obj.tasks.push({
                    id: selected_tasks.id,
                    name: selected_tasks.description,
                    priority: selected_tasks.priority,
                    edit: false,
                    headingId: '',
                    update: false,
                    modified: false,
                    sortid: 'dtask-' + task_len,
                    defaultRepCount: rep_count,
                    defaultRepCompetency: rep_competency,
                  });

                }
              }
            }
            
            this.$store.dispatch('subtasks', this.sub_tasklist_obj);
            router.push("/create-sub-tasklists/" + this.$route.params.task_list_id);
          },
          checkTasksAction: function(task_id) {
            var duplicate_flag = 0;
            var headingIndex =  this.$route.params.heading_index;
            if(this.subTaskIndex >= 0) {
              for(var i=0; i < this.sub_tasklist_obj.skills[this.subTaskIndex].tasks.length; i++)  {
                if(task_id == this.sub_tasklist_obj.skills[this.subTaskIndex].tasks[i].id) {
                  duplicate_flag = 1;
                }
              }
            }
            for(var i=0; i < this.sub_tasklist_obj.tasks.length; i++)  {
              if(task_id == this.sub_tasklist_obj.tasks[i].id) {
                duplicate_flag = 1;
              }
            }
            return duplicate_flag;
          },
          showTasklistofPaginated() {
             this.fetchTasklistitems();
             this.filterFlag = false;
          },
          showPrivateTasklistofPaginated() {
             this.fetchPrivateTasklistitems();
             this.filterFlag = false;
          },
          sortMethod: function(field) {
            this.publicSortField = field;
            if(this.publicSortBy == 'ASC') {
              this.publicSortBy = 'DESC';
            }
            else {
              this.publicSortBy = 'ASC';
            }
            this.fetchTasklistitems();
          },
          sortPrivateMethod: function(field) {
            this.privateSortField = field;
            if(this.privateSortBy == 'ASC') {
              this.privateSortBy = 'DESC';
            }
            else {
              this.privateSortBy = 'ASC';
            }
            this.fetchPrivateTasklistitems();
          },
          fetchTasklistitems() {
            this.loading = true;
            if(this.filterFlag) {
               this.currentPage = 1;
            }
            const params = { _page: this.currentPage }
            if (this.search_keyword) {
              params.name = this.search_keyword
            }
            if (this.search_status) {
              params.status = this.search_status
            }
            if (this.search_priority) {
              params.priority = this.search_priority
            }
            if (this.publicSortField) {
              params.sortfield = this.publicSortField
            }
            if (this.publicSortBy) {
              params.sortby = this.publicSortBy
            }

            params.tasklistid = this.$route.params.task_list_id;
            axios.get('/tasks', {
                   params: params
            })
            .then((resp) => {
                  this.loading = false;
                  for(var i=0; i<resp.data.data.length; i++) {
                    resp.data.data[i].edit = false;
                  }
                  this.tasks = resp.data.data;
                  this.currentPage = resp.data.page;
                  this.rows = resp.data.total_rows;
            })
            .catch(error => {

            });
          },
          fetchPrivateTasklistitems() {
            this.privateLoading = true;
            if(this.filterFlag) {
               this.privateCurrentPage = 1;
            }
            const params = { _page: this.privateCurrentPage }
            if (this.search_keyword) {
              params.name = this.search_keyword
            }
            if (this.search_status) {
              params.status = this.search_status
            }
            if (this.search_priority) {
              params.priority = this.search_priority
            }
            if (this.privateSortField) {
              params.sortfield = this.privateSortField
            }
            if (this.privateSortBy) {
              params.sortby = this.privateSortBy
            }
            params.tasklistid = this.$route.params.task_list_id;
            axios.get('/private_tasks', {
                   params: params
            })
            .then((resp) => {
                  this.privateLoading = false;
                  for(var i=0; i<resp.data.data.length; i++) {
                    resp.data.data[i].edit = false;
                  }
                  this.privateTasks = resp.data.data;
                  this.privateCurrentPage = resp.data.page;
                  this.privateRows = resp.data.total_rows;
            })
            .catch(error => {

            });
          },
          toggleDropdown (id) {
            document.getElementById(id).classList.toggle("show");
          },
          filterTasklistitems() {
             this.filterFlag = true;
             this.fetchTasklistitems();
             if((this.masterAdmin == false) || (this.$store.state.switch_admin_username)) {
              this.fetchPrivateTasklistitems();
             }
          },
          hideActionMenu(e) {
            var matches = document.getElementsByClassName('dropdown-content');
            for (var i=0; i<matches.length; i++) {
              var container = document.getElementById('dropdown-container'+ i);

              if (!container.contains(e.target)) {
                   if (document.getElementById('actionDropdown' + i).classList.contains("show")) {
                      document.getElementById('actionDropdown' + i).classList.remove('show');
                   }
              }
            }
          },
          hidePrivateActionMenu(e) {
             var matches = document.getElementsByClassName('dropdown-content-private');
             for (var i=0; i<matches.length; i++) {
               var container = document.getElementById('dropdown-container-private'+ i);

               if (!container.contains(e.target)) {
                    if (document.getElementById('actionPrivateDropdown' + i).classList.contains("show")) {
                       document.getElementById('actionPrivateDropdown' + i).classList.remove('show');
                    }
               }
            }
          },
          updateTaskStatus(task_id, status_text) {
            this.showOverlay = true;
            axios('/tasks/' + task_id,
             {
               method: 'PATCH',
               data: { "status": status_text},
             }
            )
            .then((resp) => {
              this.showOverlay = false;
              this.fetchTasklistitems();
              if((this.masterAdmin == false) || (this.$store.state.switch_admin_username)) {
                this.fetchPrivateTasklistitems();
              }
            })
            .catch(error => {
                if(error.response.data.message == 'Access denied.') {
                  router.push("/forbidden");
                }
            });
          },
          deactivateTaskConfirm(task_id) {
            this.isDeactivateModalVisible = true;
             this.deactivateId = task_id;
          },
          deactivateTask(task_id) {
            this.isDeactivateModalVisible = false;
            this.showOverlay = true;
            axios('/tasks/' + task_id,
              {
                method: 'PATCH',
                data: { "status": 'DEACTIVATED'},
              }
            )
            .then((resp) => {
              this.showOverlay = false;
              this.fetchTasklistitems();
              if((this.masterAdmin == false) || (this.$store.state.switch_admin_username)) {
                this.fetchPrivateTasklistitems();
              }
            })
            .catch(error => {
              if(error.response.data.message == 'Access denied.') {
                router.push("/forbidden");
              }
            });
          },
          deleteTaskConfirm: function(task_id, taskDescription) {
            axios('/check-task-repetition-count/' + task_id,
               {
                 method: 'GET',
               }
             )
            .then((resp) => {
                if (resp.data.isTaskDeletion) {
                  this.isDeleteModalVisible = true;
                  this.id = task_id;
                } else {
                  this.isTaskRepetitionCountModalVisible = true;
                  this.taskDescription = taskDescription;
                }
             })
            .catch(error => {

            });
          },
          deleteTask: function(task_id) {
            this.isDeleteModalVisible = false;
            this.showOverlay = true;
            axios('/tasks/' + task_id,
               {
                 method: 'DELETE',
               }
             )
            .then((resp) => {
                this.showOverlay = false;
                this.fetchTasklistitems();
                if((this.masterAdmin == false) || (this.$store.state.switch_admin_username)) {
                  this.fetchPrivateTasklistitems();
                }
             })
            .catch(error => {

            });
          },
          tasklistToolTip: function (tasklists) {
            tasklists = tasklists.split('|');
            this.tasklist_lists = tasklists;
            this.isTaskListModalVisible = true;
          },
          scrollToElement(type) {
            const el = this.$el.getElementsByClassName('page_to_'+type)[0];
            if (el) {
              el.scrollIntoView({behavior: 'smooth'});
            }
          }
        },
        created: function () {
          this.task_list_id = this.$route.params.task_list_id;
          this.subTaskIndex = this.$route.params.subtask_index;
          var roles = this.$store.state.roles;
          if((this.$store.state.page_url) && (this.$store.state.page_url === 'Tasks')) {
            this.selectedComponent = this.$store.state.active_tab;
          }
          if(roles.indexOf('ROLE_MASTER_ADMIN') > -1) {
            this.masterAdmin = true;
          }
          if((roles.indexOf('ROLE_ADMIN') > -1) || (this.$store.state.switch_admin_username)) {
            this.admin = true;
          }
          if(this.$store.state.sub_tasks) {
            this.sub_tasklist_obj = this.$store.state.sub_tasks;
          }
          this.fetchTasklistitems();
          if((this.masterAdmin == false) || (this.$store.state.switch_admin_username)) {
            this.fetchPrivateTasklistitems();
          }
        },
        mounted() {
          document.addEventListener('click', this.hideActionMenu);
          document.addEventListener('click', this.hidePrivateActionMenu);
        },
        beforeDestroy() {
          document.removeEventListener('click', this.hideActionMenu);
          document.removeEventListener('click', this.hidePrivateActionMenu);
        },


}
</script>

<style scoped>
.dropdown {
  position: absolute;
  display: inline-block;
  right: 0;
  left: 0;
}
.back-btn-wrapper {
  width: 84% !important;
}
.edit-action-btn {
  width: 85px;
  margin-right: 5px;
}
input {
  border: 1px solid #CCC;
}
.in-use-button {
  width: 60px;
  margin-left: 5px;
  padding: 2px 0px;
  font-size: 12px;
  border-radius: 46%;
  line-height: 17px;
}
.btn-dark-grey, .btn-dark-grey:hover, .btn-dark-grey:focus {
  background-color: #555;
  color: #FFF;
  border: 1px solid #555;
}
.space-wrapper {
  padding-right: 10px;
}
.create_tasks_status {
  margin: 10px 0px 0px 30px;
}
@media(max-width:991px) {
  .create_tasks_status {
    margin: 10px 0px 0px 00px;
  }
}
.tasks_heading_row {
  background-color: #8b8b8b;
  line-height: 30px;
  color: #FFF;
  padding: 3px 0px;
  margin-bottom: 0px;
  margin-right: 0px;
  margin-left: 0px;
}
*, *::before, *::after {
  outline: none;
}
.submit {
  margin-top: 4px;
}
.card-text label {
  display: inline;
}
.tasklist-item {
    padding: 12px 0px 12px 0px;
}
hr {
    border-top: 2px solid #8b8b8b;
    margin: 0px;
}
.scroll_box {
  padding: 0;
  display: flex;
  justify-content: end;
}
.scroll_up_down {
  background-color: #efac91;
  padding: 5px;
  text-align: center;
  width: 40px;
}
.angle_font {
  color: #FFF !important;
  font-size: 1.8rem !important;
}
.page_angle_down { margin: 10px 15px; }
</style>
<style>
.tab_header_class .card-header {
  background: none;
  border-bottom: 3px solid #00ACEE;
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
}
.tab_header_class .card-header:first-child {
  border-radius: calc(0.25rem - 1px) calc(0.25rem - 1px) 0 0;
}
.tab_header_class .card-header-tabs {
    margin: 0 !important;
    margin-right: -0.625rem !important;
    margin-bottom: -0.75rem !important;
    margin-left: -0.625rem !important;
    border-bottom: 0;
    float: none;
    width: auto;
    padding: 0 !important;
    border-radius: 0 !important;
    box-shadow: none !important;
}
.tab_header_class .card-header-tabs li {
    width: auto;
}
.tab_header_class .nav-tabs .nav-link.active, .tab_header_class .nav-tabs .nav-item.show .nav-link {
  color: #fff;
  background-color: #00ACEE;
  border-color: #dee2e6;
  border-top: 0;
  border: 1px solid #00ACEE;
  border-radius: 0 !important;
  border-top-left-radius: 0.25rem !important;
  border-top-right-radius: 0.25rem !important;
}
.tab_header_class .nav-link {
    display: block;
    padding: 0.5rem 1rem;
}
.tab_header_class .card-header li a {
    font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/choose_tasks.vue